export default "__VITE_ASSET__3367665e__"